angular.module('impactx.catalog').controller('CatalogRuleCheckItemsDetailListCtrl',
    CatalogRuleCheckItemsDetailListCtrl);

CatalogRuleCheckItemsDetailListCtrl.$inject = ['$routeParams'];

function CatalogRuleCheckItemsDetailListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalog/templates/catalogrulecheckitemsdetaillist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruleitemsresultlist',
        id: "catalogrulecheckitemsdetaillist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}